var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v("\n  EXPERIENCE MANAGER\n  "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.dataSetup.title.$error } },
        [
          _c("label", [_vm._v(" Title ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { "max-length": 255, placeholder: "Input Title" },
            model: {
              value: _vm.$v.dataSetup.title.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.dataSetup.title, "$model", $$v)
              },
              expression: "$v.dataSetup.title.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.dataSetup.form_ui.$error } },
        [
          _c("label", [_vm._v(" Select Experience Manager ")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              "load-options": _vm.loadOptionsFormUI,
              "is-async": true,
              "cache-option": false,
              placeholder: "Select experience manager",
              "value-format": "object",
              label: "name"
            },
            model: {
              value: _vm.$v.dataSetup.form_ui.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.dataSetup.form_ui, "$model", $$v)
              },
              expression: "$v.dataSetup.form_ui.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.dataSetup.default_view.$error } },
        [
          _c("label", [_vm._v(" Select View ")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              options: _vm.listDefaultView,
              label: "name",
              "value-format": "object",
              placeholder: "Select view"
            },
            model: {
              value: _vm.$v.dataSetup.default_view.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.dataSetup.default_view, "$model", $$v)
              },
              expression: "$v.dataSetup.default_view.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeForm }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  { staticClass: "btn blue", on: { click: _vm.saveForm } },
                  [_vm._v("\n          Save\n        ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e7ad84a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e7ad84a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/widget-component/jExperienceManagerSetup.vue
// module id = null
// module chunks = 